<template>
  <div class="row align-items-start">
    <div class="col-md-7">
      <div class="text-break font-weight-600">{{ destinationUrl }}</div>
    </div>
    <div class="col-md-5">
      <small v-if="row.video_label || row.audio_label" class="text-muted d-block">
        <span v-if="row.video_label"
          ><strong>Video:</strong> {{ row.video_label }}</span
        >
        <span v-if="row.video_label && row.audio_label"> · </span>
        <span v-if="row.audio_label"
          ><strong>Audio:</strong> {{ row.audio_label }}</span
        >
      </small>
      <small
        v-else-if="row.state"
        class="text-muted d-block text-capitalize"
        >{{ row.state }}</small
      >
      <small v-else class="text-muted d-block">—</small>
      <small
        v-if="row.state && (row.video_label || row.audio_label)"
        class="text-muted d-block mt-1 text-capitalize"
        >State: {{ row.state }}</small
      >
    </div>
  </div>
</template>

<script>
/**
 * Primary: Brightcove `job.outputs.rtmp[]` (url, video_label, audio_label).
 * Legacy: `rtmp` prop for API `rtmp_outputs` rows (connection_info, state).
 */
export default {
  name: "RtmpOutputRow",
  props: {
    output: {
      type: Object,
      default: null,
    },
    rtmp: {
      type: Object,
      default: null,
    },
  },
  computed: {
    row() {
      return this.output || this.rtmp || {};
    },
    destinationUrl() {
      const r = this.row;
      if (!r) return "";
      if (r.url) return r.url;
      const ci = r.connection_info;
      if (!ci) return "";
      if (ci.url) return ci.url;
      if (!ci.host) return "";
      const protocol = ci.rtmps ? "rtmps://" : "rtmp://";
      const port =
        ci.port && ci.port !== 1935 && ci.port !== 443 ? `:${ci.port}` : "";
      const application = ci.application || "live";
      const streamName = ci.streamName || ci.stream_name || "";
      return `${protocol}${ci.host}${port}/${application}/${streamName}`.replace(
        /\/+$/,
        ""
      );
    },
  },
};
</script>

<style scoped></style>
